import { GET_TTFB_DISTRIBUTORS_REQUEST,
    GET_TTFB_DISTRIBUTORS_SUCCESS,
    GET_TTFB_DISTRIBUTORS_FAILURE,
    RESET_TTFB_DISTRIBUTORS } from '../../actions/business/constants';

const INITIAL_STATE = {
    fetching: false,
    page: 1,
    data: null,
    error: false,
}

export default function distributors(state = INITIAL_STATE, action) {
    switch(action.type) {
        case GET_TTFB_DISTRIBUTORS_REQUEST:
            return {
                ...state,
                fetching: true
            }
        case GET_TTFB_DISTRIBUTORS_SUCCESS:
            return {
                ...state,
                fetching: false,
                page: state.page + 1,
                data: state.page === 1
                    ? action.payload
                    : {
                        ...state.data,
                        data: [...state.data.data,
                        ...action.payload.data]
                    },
                hasEnd: (!action.payload.data.length
                    || (!!action.payload.data.length
                        && action.payload.data.length < 20)),
                hasFetched: true
            }
        case GET_TTFB_DISTRIBUTORS_FAILURE:
            return {
                ...state,
                ...(!action.error.__CANCEL__ && {
                    error: true,
                    errorObj: action.error.error
                }),
                fetching: false,
            }
        case RESET_TTFB_DISTRIBUTORS:
            return INITIAL_STATE
        default:
            return state;
    }
}